import PortablesStats from './PortablesStats.vue';

if (document.getElementById('portables-stats-table')) {
  const table = document.getElementById('portables-stats-table');

  var app = new Vue({
      el: table,
      template: `
        <PortablesStats
          :campaigns="this.campaigns"
          :seasonals="this.seasonals"
          :portables="this.portables"
          :orderedItems="this.orderedItems"
        />
      `,
      data(){
        return {
          campaigns: JSON.parse(table.dataset.campaigns),
          seasonals: JSON.parse(table.dataset.seasonals),
          portables: JSON.parse(table.dataset.portables),
          orderedItems: JSON.parse(table.dataset.orderedItems)
        };
      },
      created() {
          window.vue = this;
      },
      components: {
        PortablesStats
      },
  });
}